import React, { useContext, useEffect } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import { Tabs } from 'components/Tabs'
import { StatementContext } from 'utils/context/StatementsContext'
import { LoaderContext } from 'utils/context/LoaderContext'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { ReceiverDashboard } from 'components/ReceiverDashboard'
import { SenderDashboard } from 'components/SenderDashboard'

const Home = () => {
    const navigate = useNavigate()
    const isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated'))
    const {
        isReceiver,
        isSender,
        getUserPermissionsSummary,
    } = useContext(StatementContext)
    const {
        isLoading
    } = useContext(LoaderContext)

    useEffect(() => {
        getUserPermissionsSummary()
    }, [])

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/signin')
        }
    }, [isAuthenticated, navigate])

    const content = () => {
        if (isSender === null && isReceiver === null && isLoading) {
            return <LoadingSpinner />
        }
        if ((isSender && isReceiver)) {
            return <Tabs />
        }
        if (isReceiver) {
            return (
                <ReceiverDashboard />
            )
        }
        if (isSender) {
            return (
                <SenderDashboard />
            )
        }
        
        if (!isLoading) {
            navigate('/error')
        }
    }

    return (
        <Container>
            <Row>{content()}</Row>
        </Container>
    )
}

export default Home